import React, {FC} from 'react';

import {Box, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';

import CloseOutlinedIcon from 'assets/icons/closedOutlinedIcon';
import basketPicture from 'assets/images/new-empty-basket.png';
import {useAppSelector} from 'hooks';
import {StyledDialog, StyledBottomSheet} from 'views/address-drawer/styles';

import {BulletPoints} from './styles';

export interface MinimumBasketAmountModalProps {
  open: boolean;
  onClose: () => void;
  isReactNativeWebView: boolean;
}

export const MinimumBasketAmountModal: FC<MinimumBasketAmountModalProps> = ({open, onClose, isReactNativeWebView}) => {
  const {t} = useTranslation();
  const {basket} = useAppSelector((state) => state.basket);
  const ModalContainer = isReactNativeWebView ? StyledBottomSheet : StyledDialog;

  return (
    <ModalContainer open={open} onClose={onClose} anchor="bottom">
      <DialogTitle>
        <IconButton onClick={onClose}>
          <CloseOutlinedIcon color="secondary" fontSize="medium" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
          <Box component="img" width={160} height={160} src={basketPicture}></Box>
        </Box>
        <Typography fontSize={20} fontWeight={700}>
          {t('recommendations.checkoutWithMakro')}
        </Typography>
        <BulletPoints isReactNativeView={isReactNativeWebView}>
          <li>
            <Typography fontSize={16} fontWeight={400}>
              <Trans i18nKey="recommendations.orderRequiresMinimum" values={{amount: basket?.prices?.minimumBasket}} />
            </Typography>
          </li>
          <li>
            <Typography fontSize={16} fontWeight={400}>
              {t('recommendations.noMinPriceFor3P')}
            </Typography>
          </li>
        </BulletPoints>
      </DialogContent>
    </ModalContainer>
  );
};

MinimumBasketAmountModal.displayName = 'MinimumBasketAmountModal';
